import { Atom } from "AppReact";
import styled, { css } from "styled-components";

const template = styled.div`
  ${({ displayState }) => css`
    font-size: ${displayState?.fontSize ?? '10px'};
    color: ${displayState?.color ?? ''};
    line-height: ${displayState?.lineHeight ?? ''};
    font-weight: ${displayState?.fontWeight ?? ''};
    letter-spacing: ${displayState?.letterSpacing ?? ''};
    text-decoration: ${displayState?.textDecoration ?? ''};
    
    ${displayState?.clickable && css`
      &:hover {
        text-decoration: underline;
      }
    `}
  `}
`;

export default Atom({ type: 'label', dataType: 'string', template });
